import {FormControlLabel, Switch} from '@material-ui/core';
import React from 'react';
import {useDispatch} from 'react-redux';
import AgentNumberInput from 'Users/components/UserAdministration/UserEntry/AgentNumberInput';
import {
  addAgentNumber,
  changeCanViewAccounts,
  changeCanViewClaims,
  changeCanViewCommissionsAnd1099s,
  changeCanViewCorrespondence,
  changeCanViewPolicies,
  changeCanViewPolicyServiceRequest,
  removeAgentNumber,
  changeCanViewPendingUnderwritingRequirements,
} from 'Users/ducks/agentSupportUserType';
import {SupportAgencyAssociation} from 'Users/models/User/Agent/SupportAgencyAssociation';
import {
  ExistingTaxIdentificationNumber,
  ValidTaxIdentificationNumber,
} from 'Users/models/User/Agent/TaxIdentificationNumber';
import './AgentPortalEntry.sass';

type AgentSupportPermissionsInput = {
  taxId: ValidTaxIdentificationNumber | ExistingTaxIdentificationNumber;
  agentNumbers: SupportAgencyAssociation['agentNumbers'];
  supportAgentPermissions: SupportAgencyAssociation['supportAgentPermissions'];
  index: number;
  disabled?: boolean;
};

const AgentSupportPermissionsInput = (props: AgentSupportPermissionsInput) => {
  const {taxId, supportAgentPermissions, agentNumbers, index, disabled} = props;
  const {availableAgentNumbers} = taxId;
  const dispatch = useDispatch();

  return (
    <>
      <AgentNumberInput
        className="agency-association-section__agent-number-input"
        agentNumbers={agentNumbers}
        availableAgentNumbers={availableAgentNumbers}
        onAddAgentNumber={agentNumber => dispatch(addAgentNumber(index, agentNumber))}
        onRemoveAgentNumber={agentNumber => dispatch(removeAgentNumber(index, agentNumber))}
        disabled={!!disabled}
      />
      <p className="agency-association-section__elevated-access-label">Elevated Access:</p>
      <FormControlLabel
        label="Can View Accounts?"
        control={
          <Switch
            checked={supportAgentPermissions.canViewAccounts}
            onChange={e => dispatch(changeCanViewAccounts(index, e.target.checked))}
            color="primary"
            disabled={!!disabled}
          />
        }
      />
      <FormControlLabel
        label="Can View Policies?"
        control={
          <Switch
            checked={supportAgentPermissions.canViewPolicies}
            onChange={e => dispatch(changeCanViewPolicies(index, e.target.checked))}
            color="primary"
            disabled={!!disabled}
          />
        }
      />
      <FormControlLabel
        label="Can View Claims?"
        disabled={!supportAgentPermissions.canViewPolicies}
        control={
          <Switch
            checked={supportAgentPermissions.canViewClaims}
            onChange={e => dispatch(changeCanViewClaims(index, e.target.checked))}
            color="primary"
            disabled={!!disabled}
          />
        }
      />
      <FormControlLabel
        label="Can View Commissions And 1099s?"
        control={
          <Switch
            checked={supportAgentPermissions.canViewCommissionsAnd1099s}
            onChange={e => dispatch(changeCanViewCommissionsAnd1099s(index, e.target.checked))}
            color="primary"
            disabled={!!disabled}
          />
        }
      />
      <FormControlLabel
        label="Can View Policy Service Request?"
        control={
          <Switch
            checked={supportAgentPermissions.canViewPolicyServiceRequest}
            onChange={e => dispatch(changeCanViewPolicyServiceRequest(index, e.target.checked))}
            color="primary"
            disabled={!!disabled}
          />
        }
      />
      <FormControlLabel
        label="Can View Correspondence?"
        control={
          <Switch
            checked={supportAgentPermissions.canViewCorrespondence}
            onChange={e => dispatch(changeCanViewCorrespondence(index, e.target.checked))}
            color="primary"
            disabled={!!disabled}
          />
        }
      />
      <FormControlLabel
        label="Can View Pending Requirements?"
        control={
          <Switch
            checked={supportAgentPermissions.canViewPendingUnderwritingRequirements}
            onChange={e => dispatch(changeCanViewPendingUnderwritingRequirements(index, e.target.checked))}
            color="primary"
            disabled={!!disabled}
          />
        }
      />
    </>
  );
};

export default AgentSupportPermissionsInput;
